/* WAVE HAWAII: Größen-Pills in den Produktkacheln der Kollektionsseite */
(function () {
  if (window.whPlpInit) return;
  window.whPlpInit = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wh-size]');
    if (!button) return;
    event.preventDefault();

    var tile = button.closest('[data-wh-tile]');
    if (!tile) return;

    var wasSelected = button.getAttribute('aria-pressed') === 'true';
    tile.querySelectorAll('[data-wh-size]').forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
      b.classList.remove('is-selected');
    });

    var baseUrl = tile.getAttribute('data-url');
    var variantId = button.getAttribute('data-variant-id');
    var targetUrl = baseUrl;

    if (!wasSelected) {
      button.setAttribute('aria-pressed', 'true');
      button.classList.add('is-selected');
      targetUrl = baseUrl + (baseUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variantId;
    }

    tile.querySelectorAll('[data-wh-tile-link]').forEach(function (link) {
      link.setAttribute('href', targetUrl);
    });

    var quickBuy = tile.querySelector('[data-wh-quick-buy]');
    if (quickBuy && !wasSelected) {
      quickBuy.setAttribute('handle', tile.getAttribute('handle') + '?variant=' + variantId);
    }
  });
})();
